<template>
	<div v-on="$listeners" class="row-card-info-wrapper row-card-info-wrapper--border">
		<div class="row-card-info-wrapper__main">
			<div class="row-card-info-wrapper__title">{{ formattedItem.title }}</div>
			<div
				v-if="formattedItem.date"
				class="row-card-info-wrapper__date"
				:class="{ 'row-card-info-wrapper__date--margin': !getCoverPicture }"
			>
				{{ formatDateFn(formattedItem.date) }}
			</div>
		</div>
		<van-image v-if="getCoverPicture" :src="getCoverPicture" fit="cover" class="row-card-info-wrapper__cover" />
	</div>
</template>

<script setup>
import { computed } from 'vue';
import { formatIrYear } from '@/utils/api';
import { Image as VanImage } from 'vant';
import { useModuleDefaultCover } from '@rebuild/hooks/comp/useModuleDefaultCover';

/**
 * 组件属性定义
 * @typedef {Object} Props
 * @property {Object} item - 原始数据对象
 * @property {Function} [formatter] - 可选的格式化函数，用于将原始数据转换为组件所需格式
 */
const props = defineProps({
	item: {
		type: Object,
		default: () => ({})
	},
	/**
	 * 格式化函数，用于字段重命名或数据转换
	 * @param {Object} rawItem - 原始数据对象
	 * @returns {Object} 返回的对象会与原始数据合并
	 * @example
	 * :formatter="data => ({ time: data.stime })"
	 */
	formatter: {
		type: Function,
		default: null
	}
});

const formattedItem = computed(() => {
	if (props.formatter && typeof props.formatter === 'function') {
		const formattedData = props.formatter(props.item);
		// 将格式化后的数据与原始数据合并，formatter 返回的字段优先级更高
		return { ...props.item, ...formattedData };
	}
	return props.item;
});

const { getDefaultCover } = useModuleDefaultCover();
const getCoverPicture = computed(() => {
	if (formattedItem.value.imageUrl) return formattedItem.value.imageUrl;
	return getDefaultCover('investment_activity');
});

const formatDateFn = date => formatIrYear(date);
</script>

<style lang="less" scoped>
@import '@/style/mixins';

.row-card-info-wrapper {
	padding-bottom: 0.14rem;
	display: flex;

	&--border {
		.thinner-border-bottom(#e8eaef);
	}
	& + .row-card-info-wrapper {
		margin-top: 0.14rem;
	}

	.row-card-info-wrapper__main {
		flex: 1;
		width: 0;
		display: flex;
		flex-direction: column;
		justify-content: space-between;

		.row-card-info-wrapper__title {
			color: #333;
			/* 15/H5-medium */
			font-family: 'PingFang SC';
			font-size: 0.15rem;
			font-style: normal;
			font-weight: 500;
			line-height: 140%; /* 21px */
			.text-overflow-multi-row(2);
		}
		.row-card-info-wrapper__date {
			color: #989898;
			/* 11/B2-regular */
			font-family: 'PingFang SC';
			font-size: 0.11rem;
			font-style: normal;
			font-weight: 400;
			line-height: 140%; /* 15.4px */

			&--margin {
				margin-top: 0.08rem;
			}
		}
	}

	.row-card-info-wrapper__cover {
		flex: none;
		margin-left: 0.08rem;
		width: 1.08rem;
		height: 0.81rem;
		border-radius: 0.02rem;
		overflow: hidden;
	}
}
</style>
